import { useContext } from 'react';
import { MultiPortfolioReviewContext } from '../components/common/MultiPortfolioReviewContext';
import { MultiHistoricalPortfolioContext } from '../components/specialized/MultiHistoricalPortfolioContext';
import { useUploadHistoricalPortfolioAllocator } from '../useUniversalUploaderAllocator';
import { useMultiHistoricalRightPaneContentPortfolio } from './useMultiHistoricalRightPaneContentPortfolio';
import { getRowId, useSharedMultiPortfolioRightPaneContent } from './useSharedMultiPortfolioRightPaneContent';

export const useMultiHistoricalRightPaneContent = () => {
  const { selectedDate, rangeAnalysis } = useContext(MultiHistoricalPortfolioContext);
  const {
    data: { parsedResults, selectedIndex },
  } = useContext(MultiPortfolioReviewContext);
  const { selectedDateFilteredPortfolio, completePortfolio } = useMultiHistoricalRightPaneContentPortfolio();
  const excludedInvestments = parsedResults[selectedIndex]!.excludedInvestments;

  // actions like remapping require the complete portfolio
  const { accessMode, applyInvestmentRemap, includeInvestment, excludeInvestment } =
    useSharedMultiPortfolioRightPaneContent(completePortfolio);

  // the right pane displays only the selected as-of-date portfolio so we send the filtered portfolio only
  const { rowData, columnDefs, autoGroupColumnDefs, rowClassRules } = useUploadHistoricalPortfolioAllocator({
    portfolio: selectedDateFilteredPortfolio,
    excludedInvestments,
    accessMode,
    applyInvestmentRemap,
    selectedDate,
    includeInvestment,
    excludeInvestment,
    rangeAnalysis,
  });
  return {
    rowData,
    columnDefs,
    autoGroupColumnDefs,
    rowClassRules,
    getRowId,
  };
};
